/**
 * External Dependencies
 */

import "jquery";
import "bootstrap";
import "./tinyslider";
import "./block-videos";
import "./jquery.mousewheel";
import "./magnific-popup";
import "./mapplic";
import "./mapplic-modification";
import "./print-form-summary";
import "./rebelware-middleware-utm-tracking";
import "./block-mp3-library";

import simpleParallax from "simple-parallax-js";

$(function () {
  let modals = $(".video-modal");
  modals.each(function (k, v) {
    $(v).on("hidden.bs.modal", function () {
      console.log("hidden bs:");
      let iframe = $(v).find("iframe");
      console.log(iframe,"iframe");

      if(iframe.length == 0){

        let html_vid = $(v).find("video");
        html_vid.get(0).pause();

      } else {
        let temp = iframe.attr("src");

      iframe.attr("src", "");
      setTimeout(function () {
        iframe.attr("src", temp);
      }, 100);
      }
      
    });
  });

  let search_input = document.querySelector("input#search");
  if (search_input) {
    window.onload = function () {
      var input = search_input.focus();
    };
  }

  if ($(".carousel").length > 0) {
    $(".carousel").carousel();
  }
});

// Detect whether the user is running IE11
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// Passive event listeners
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};

function is_touch_device() {
  return !!("ontouchstart" in window);
}

//Stick Nav 

// Fix nav on scroll (excluding mobile)
const scrollpos = window.scrollY;
const header = document.querySelector("header");
const icon = document.getElementById("home-icon");
const header_height = header.offsetHeight;

const add_class_on_scroll = () => header.classList.add("sticky");
const remove_class_on_scroll = () => header.classList.remove("sticky");

// Function to check if the screen width is above a certain threshold
const isScreenAboveThreshold = () => window.innerWidth > 768; // Adjust the threshold as needed

// Add an event listener for scrolling only if the screen width is above the threshold
if (isScreenAboveThreshold()) {
  window.addEventListener('scroll', function() { 
    const currentScrollPos = window.scrollY;

    if (currentScrollPos >= header_height) { 
      add_class_on_scroll();
      icon.style.display = 'block';
    }
    else { 
      remove_class_on_scroll();
      icon.style.display = 'none';
    }
  });
}



$(document).ready(() => {

  $("#close").click(function() {
    $(".dynamic-banner").hide();
  });

  //Remove footer slider links
  $("#tchsp ul li a").contents().unwrap();

  //Campus Map init
  if ($.isFunction($.fn.mapplic)) {
    var mapplic = $("#mapplic").mapplic({
      source: '/app/themes/wcbay/data.json")',
      height: "auto",
      marker: "hidden",
    });
  }

  /**
   * Parallax images in feature blocks
   */
  if (
    !isIE11 &&
    window.innerWidth > 640 &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    var ParallaxBlocks = document.querySelectorAll(".is-style-parallax");
    // console.log(ParallaxBlocks, "parallax blocks");

    ParallaxBlocks.forEach((block) => {
      // console.log(block.dataset,"block");
      new simpleParallax(block.querySelector(".parallax-img"), {
        overflow:
          block.dataset.overflow !== undefined ? block.dataset.overflow : true,
        scale: block.dataset.scale !== undefined ? block.dataset.scale : 2,
        orientation:
          block.dataset.orientation !== undefined
            ? block.dataset.orientation
            : "up",
        delay: 0,
        maxTransition:
          block.dataset.maxTransition !== undefined
            ? block.dataset.maxTransition
            : "100%",
      });
    });
  }

  // Hamburger Menu
  $(".hamburger").click(function () {
    $(this).toggleClass("is-active");
  });

  //Location page collapse
  $(".faqToggle").click(function () {
    if ($(this).children("div:first").children("a:first").hasClass("collapsed")) {
      $(this).children("div:first").children("a:first").addClass("minusPlus");
      $(this).children("div:first").children("a:first").removeClass("plusMinus");
      $(this).children("div:first").children("a:first").removeClass("collapsed");
    } else {
      $(this).children("div:first").children("a:first").addClass("plusMinus");
      $(this).children("div:first").children("a:first").removeClass("minusPlus");
      $(this).children("div:first").children("a:first").addClass("collapsed");
    }
  });
});

function isInViewObserverInit(e) {
  var options = {
    root: null,
    rootMargin: "20px",
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  };

  if ("IntersectionObserver" in window) {
    let inView = new IntersectionObserver(function (e, n) {
      e.forEach(function (e) {
        if (e.isIntersecting) {
          // console.log(e);
          let n = e.target;
          n.dataset.iRatio = e.intersectionRatio;
          if (n.dataset.isInViewWatcher !== "") {
            if (e.intersectionRatio >= n.dataset.isInViewWatcher) {
              n.classList.add("isInView");
              console.log(
                "is In view: " +
                  e.intersectionRatio +
                  " >= " +
                  n.dataset.isInViewWatcher
              );
              inView.unobserve(n);
            }
          } else {
            n.classList.add("isInView");
            inView.unobserve(n);
          }
        }
      });
    }, options);

    e.forEach(function (e) {
      inView.observe(e);
    });
  } else {
    e.forEach(function (e) {
      let n = e.target;
      n.classList.add("isInView");
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var e = [].slice.call(document.querySelectorAll("[data-is-in-view-watcher]"));
  isInViewObserverInit(e);
});

$(function () {
  // $('.collapse').on('hidden.bs.collapse', function () {
  //   if(jQuery('.block-featuredfaq .collapse.show').length == 0){
  //     $(this).collapse('show');
  //   }
  // });

  /**
   * Disabe the form button when clicked
   */
$(".gform_wrapper form").on("submit", function(e){
    $(this).find(".gform_button").addClass("disabled").prop("disabled");
  });


  $(window).on("scroll", function (e) {
    e.stopPropagation();
    if (window.pageYOffset >= 1500) {
      $(".back2top").addClass("show");
    } else {
      $(".back2top").removeClass("show");
    }
  });

  $(".back2top").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("html, body").animate({ scrollTop: 0 }, 500);
    $(this).addClass("is-active");
  });
});

var phone = "()-+. 0123456789";
var numb = "0123456789";
var zip = "0123456789-";
var alpha = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789";

function res(t, v) {
  var w = "";
  var i,
    x = 0;
  for (i = 0; i < t.value.length; i++) {
    x = t.value.charAt(i);
    if (v.indexOf(x, 0) != -1) w += x;
  }
  t.value = w;
}

let zip_fields = document.querySelectorAll('[autocomplete="postal-code"]');
zip_fields.forEach(function (_zip) {
  _zip.addEventListener("keyup", function (event) {
    res(event.target, zip);
  });
});

// set carouselQuote items to equal height
let cards = $("#carouselQuotes .carousel-item"), //get all cards
  heights = [], //height values array
  tallest; //tallest card

function normalizeHeights() {
  cards.each(function () {
    heights.push($(this).height());
  });
  tallest = Math.max.apply(null, heights);
  cards.each(function () {
    $(this).css("min-height", tallest + "px");
  });
}

$(window).on("resize orientationchange", function () {
  (tallest = 0), (heights.length = 0);
  cards.each(function () {
    $(this).css("min-height", "0");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  normalizeHeights();
});
